"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerBackground = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const BannerBackground = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  height: "1268",
  viewBox: "0 0 1699 1268",
  width: "1699",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/_react.default.createElement("radialGradient", {
  id: "a",
  cx: "41.263%",
  cy: "-2.362%",
  gradientTransform: "matrix(.45463 .7923 -.59037 .61013 .211 -.336)",
  r: "129.196%"
}, /*#__PURE__*/_react.default.createElement("stop", {
  offset: "0",
  stopColor: "#fff"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: ".36054",
  stopColor: "#fff"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "1",
  stopColor: "#b3b7bc"
})), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "m0 0h1699v1266h-1699z",
  fill: "url(#a)"
}), /*#__PURE__*/_react.default.createElement("circle", {
  className: "cds-Teaser-DMKBackgroundCircle",
  cx: "633.6",
  cy: "633.6",
  fill: "#40b0e3",
  r: "633.6"
})));
exports.BannerBackground = BannerBackground;
//# sourceMappingURL=BannerBackground.js.map